(function notificationModuleDefinition() {

    'use strict';

    angular.module('Notification', ['ui.router', 'ui.tree', 'ui.treeExtend', 'ui.bootstrap.modal', 'Config', 'Entities'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function employeeFileConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('notification-find', {
                    url: "/Notification/Find",
                    templateUrl: config.resourceUrl('/views/notification/notification-find.html'),
                    controller: 'NotificationFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('NOTIFICATION READ')
                });
            }
        ]);
})();